import { CustomerOrderOfferProfitMarginApi } from "src/api/generated/erp/sales/customerOrderOffer/api/customerOrderOfferProfitMarginApi.ts";
import { CustomerOrderOfferProfitMarginView } from "src/api/generated/erp/db/types/tables/customerOrderOfferProfitMarginView.ts";
import { InlineCrudDataGrid } from "src/components/common/dataGrid/crud/InlineCrudDataGrid.tsx";
import { ClientSideDataGridModel } from "src/components/common/dataGrid/gridModel/ClientSideDataGridModel.tsx";
import { getProfitMarginColumns } from "src/components/views/erp/sales/masterData/customerPriceGroups/CustomerPriceGroupProfitMarginsDataGrid.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";
import { useAavoToast } from "src/components/common/toast/AavoToastContext.tsx";
import i18n from "i18next";

export interface CustomerOrderOfferProfitMarginsDataGridProps {
	customerOrderOfferId: number;
	editable: boolean;
	onMarginsSaved: () => Promise<unknown>;
}

export function CustomerOrderOfferProfitMarginsDataGrid({
	customerOrderOfferId,
	editable,
	onMarginsSaved,
}: CustomerOrderOfferProfitMarginsDataGridProps) {
	const { showToast } = useAavoToast();
	return (
		<ClientSideDataGridModel<
			CustomerOrderOfferProfitMarginView[],
			CustomerOrderOfferProfitMarginView,
			Record<string, never>
		>
			gridId={"8B343351392B40F7"}
			fetchData={() => CustomerOrderOfferProfitMarginApi.getProfitMargins({ customerOrderOfferId })}
			getRows={(data) => data}
			initialParams={{}}
			getRowId={(row) => row.salesPartPriceGroupId}
			render={({ dataGridProps, refreshData }) => (
				<InlineCrudDataGrid<CustomerOrderOfferProfitMarginView>
					columns={getProfitMarginColumns<CustomerOrderOfferProfitMarginView>()}
					save={
						editable ?
							{
								type: "enabled",
								action: async ({ items }) => {
									await CustomerOrderOfferProfitMarginApi.saveProfitMargins({
										customerOrderOfferId,
										rows: items,
									});
									showToast({
										title: i18n.t("profit_margins_saved"),
										message: i18n.t("profit_margins_saved_recalculation_required"),
									});
									await Promise.all([refreshData(), onMarginsSaved()]);
									return items;
								},
							}
						: { type: "hidden" }
					}
					agentContext={{
						key: defineAgentUiContextKey("erp.sales.customerOffer.profitMargins.grid"),
						data: { customerOrderOfferId },
						rowFields: ["salesPartPriceGroupId", "salesPartPriceGroupName", "profitMarginPercent"],
					}}
					{...dataGridProps}
				/>
			)}
		/>
	);
}
